import { PlatformConfiguration } from '../model';

export const configuration: PlatformConfiguration = {
  button: {
    background: 'gradient',
    type: 'default',
  },
  input: {
    label: 'default',
    height: '72px',
  },
  amountInput: {
    variant: 'standard',
  },
  errors: {
    position: 'top',
    type: 'container',
  },
  balance: {
    visible: true,
  },
};
